import React from "react";

export const DashboardPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/",
      exact: true,
      component: React.lazy(() => import("../dashboard/DashboardPage")),
    },
  ],
};
